import axiosInstance from "config/AxiosConfig";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";
import { CalendarDateResp } from "domain/payload/response/Calendar/CalendarDateResp";

const CalendarService = () => {
  const eventList = async (
    token: string,
    year: number,
    month: number
  ): Promise<BaseResponse<CalendarDateResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/calendar/event/list`, {
        headers: { 
          Authorization: `Bearer ${token}`
        },
        params: {
          year: year,
          month: month
        }
      });

      return response.data;

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return {
    eventList
  };
};

export default CalendarService;